import React from 'react';
import Footer from '../header_footer/Footer';
import Navigation from '../header_footer/Navgation';
import Hero from './Hero';
import ProductList from './ProductList';
import CategoriesCarousel from './CategoriesCarousel';

export default function Home() {
  return (
    <div className='min-h-screen bg-white text-black'>
      <Navigation />
      <Hero />
      <ProductList />
      <CategoriesCarousel />
      <Footer />
    </div>
  )
}
